import { render, staticRenderFns } from "./Weblog.vue?vue&type=template&id=6020f50b&scoped=true"
import script from "./Weblog.vue?vue&type=script&lang=js"
export * from "./Weblog.vue?vue&type=script&lang=js"
import style0 from "./Weblog.vue?vue&type=style&index=0&id=6020f50b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020f50b",
  null
  
)

export default component.exports